import * as Yup from 'yup'

export const LoginSchema = Yup.object().shape({
    email: Yup
        .string()
        .email()
        .nullable()
        .label('Email')
        .required(),

    password: Yup
        .string()
        .label('Password')
        .required('Password is required'),

    reset_prompt_email: Yup
        .string()
        .email()
        .nullable()
        .label('Email')
})